import React from "react";
import { Badge } from "@/components/ui/badge";
import { ArrowLink } from "./ArrowLink";

interface NavSubMenuSectionProps {
  heading: string;
  items: {
    title: string;
    href: string;
    description?: string;
    badge?: string;
  }[];
  cta?: {
    text: string;
    href: string;
  };
}

export const NavSubMenuSection = ({
  heading,
  items,
  cta,
}: NavSubMenuSectionProps) => (
  <div className="flex min-w-[240px]">
    <div className="flex-1 flex flex-col">
      <h2 className="text-xl-semibold text-brand-primary m-0 px-xl py-md">
        {heading}
      </h2>
      <ul className="list-none p-0 m-0 pt-4xl flex flex-col gap-xs">
        {items.map(({ title, href, description, badge }) => (
          <li key={href}>
            <a
              href={href}
              className="block min-[1280px]:flex min-[1280px]:items-baseline py-lg px-xl no-underline hover:no-underline hover:bg-bg-quaternary rounded-md transition-colors"
            >
              <span className="inline-flex items-center gap-md">
                <span className="text-sm-medium text-tertiary">{title}</span>
                {badge && (
                  <Badge variant="brand" size="sm">
                    {badge}
                  </Badge>
                )}
              </span>
              {description && (
                <>
                  <span className="[display:none] min-[1280px]:inline text-sm-regular text-quaternary mx-md">
                    —
                  </span>
                  <span className="block min-[1280px]:inline text-sm-regular text-quaternary mt-xs min-[1280px]:mt-0">
                    {description}
                  </span>
                </>
              )}
            </a>
          </li>
        ))}
      </ul>
      <div className="flex-1 min-h-4xl" />
      {cta && (
        <div className="px-xl py-md">
          <ArrowLink href={cta.href}>{cta.text}</ArrowLink>
        </div>
      )}
    </div>
  </div>
);
